import { createContext } from 'react';

import { Theme as ThemeInterface } from '@interfaces';

import buildTheme from '@backend/builders/buildTheme';

const Theme = createContext<ThemeInterface>(buildTheme());

export default Theme;
